<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    class="icon-svg icon-chevron-left"
  >
    <path d="M15.7926706,3.5 C16.0592146,3.5 16.3129269,3.60515475 16.498306,3.79186626 C16.687516,3.97974386 16.7926708,4.23345612 16.7926708,4.5 C16.7926708,4.76654424 16.6875161,5.02025655 16.4995574,5.20688725 L9.706,12 L16.4995575,18.7931208 C16.6564973,18.9500607 16.7554217,19.1515407 16.784037,19.3683261 L16.7926708,19.5 C16.7926708,19.7665498 16.6875175,20.0202627 16.498306,20.2081417 C16.3100265,20.3950953 16.0580947,20.5 15.7926706,20.5 C15.526127,20.5 15.2724147,20.3948537 15.0857837,20.2068947 L7.93911342,13.0602244 C7.65666853,12.7777795 7.5,12.3999319 7.5,12.0006707 C7.5,11.6011684 7.65616933,11.2227277 7.93844676,10.9404503 L15.0845366,3.79436485 C15.2724142,3.60515475 15.5261265,3.5 15.7926706,3.5 Z" />
  </svg>
</template>
